/* angular modules */
import {Injectable} from '@angular/core';
/* ngx modules */
import {SessionStorage, SessionStorageService} from 'ngx-webstorage';
import {TranslateService} from '@ngx-translate/core';
import {Observable, zip} from 'rxjs';
/* app modules */
import {UserService} from '../user/user.service';
import {PartnerService} from '../partner/partner.service';
import {RightsService} from '../rights/rights.service';
import {LoggerService} from '../logging/logger.service';
import {LoginEventDatalayerService} from '../google-analytics/login-event-datalayer.service';
import {Router} from "@angular/router";
import {PageViewEventDatalayerService} from "../google-analytics/page-view-event-datalayer.service";
import {User} from "../user/user";
import {Localization} from "../model/localization.model";
import {Partner} from "../partner/partner";


@Injectable()
export class ApplicationService {

    @SessionStorage() gaLoginTrigger: boolean;
    @SessionStorage() gaLoginPageTrigger: boolean;

    constructor(private sessionStorageService: SessionStorageService,
                private translateService: TranslateService,
                private logger: LoggerService,
                private userService: UserService,
                private rightsService: RightsService,
                private partnerService: PartnerService,
                private loginEventDatalayerService: LoginEventDatalayerService,
                private router: Router,
                private pageViewEventDatalayerService: PageViewEventDatalayerService) {
    }

    init(loadingDone: Function) {
        this.logger.debug('ApplicationService init()');
        return zip(this.userService.getUser(), this.userService.getLocalization(), this.partnerService.getPartner(),
            (user: User, localization: Localization, partner: Partner) => {
                // Set user preferred language if this language is used for the current user's localisation
                let myLang = localization.langs[0].language;
                localization.langs.forEach(lang => {
                    if (user.preferredLanguage === lang.language) {
                        myLang = lang.language;
                    }
                });
                user.preferredLanguage = myLang;
                // user
                this.sessionStorageService.store('user', user);
                // this language will be used as a fallback when a translation isn't found in the current language
                this.translateService.setDefaultLang('en');

                // localization : languages, currency symbol, etc...
                this.sessionStorageService.store('localization', localization);

                // partner
                this.sessionStorageService.store('partner', partner);
                this.rightsService.addRight(user.role);


                this.sessionStorageService.store('isNetPriceDisplayed', user.currentMySEAccount != null);

                // the lang to use, if the lang isn't available, it will use the current loader to get them
                this.translateService.use(user.preferredLanguage).subscribe(() => {
                    // loading done
                    loadingDone();
                });

                if (this.gaLoginTrigger === false){
                  this.loginEventDatalayerService.LoginEvent(user);
                  if (this.gaLoginPageTrigger === true){
                    this.pageViewEventDatalayerService.PageViewEvent(this.router);
                    this.gaLoginPageTrigger = false;
                  }
                  this.gaLoginTrigger = true;
                } else if (this.gaLoginTrigger === null){
                  if (this.gaLoginPageTrigger === true) {
                    this.pageViewEventDatalayerService.PageViewEvent(this.router);
                  }
                  this.gaLoginTrigger = true;
                }

                // manage demo mode
                if (!this.rightsService.isActivatedDemo()) {
                    this.sessionStorageService.store('isDemoMode', false);
                }
            }
        );
    }
}
